import styled from 'styled-components';

import { container } from 'styles/grid';
import { minWidth } from 'styles/media-queries';

export const Root = styled.div`
  ${props =>
    props.hasVideo &&
    `
    display: flex;
    flex-direction: row;
    justify-content: center;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;

    > div {
      width: unset !important;
      max-height: unset !important;
    }
    
    /* Ensure video player centers properly on mobile */
    > * {
      max-width: 100%;
      width: 100%;
    }
    
    /* Target the VideoPlayer component specifically */
    [class*='VideoPlayer'] {
      max-width: 100% !important;
      width: 100% !important;
    }
  `}

  /* Fullscreen styles */
  ${props =>
    props.isFullscreen &&
    `
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    width: 100vw !important;
    height: 100vh !important;
    max-width: 100vw !important;
    max-height: 100vh !important;
    z-index: 9999 !important;
    background: #000 !important;
    
    /* Fullscreen video player styling */
    > * {
      width: 100% !important;
      height: 100% !important;
      max-width: 100% !important;
      max-height: 100% !important;
    }
    
    [class*='VideoPlayer'] {
      width: 100% !important;
      height: 100% !important;
      max-width: 100% !important;
      max-height: 100% !important;
    }
  `}

  /* Browser-specific fullscreen selectors */
  &:fullscreen {
    width: 100vw !important;
    height: 100vh !important;
    background: #000 !important;
    
    > * {
      width: 100% !important;
      height: 100% !important;
    }
  }

  &:-webkit-full-screen {
    width: 100vw !important;
    height: 100vh !important;
    background: #000 !important;
    
    > * {
      width: 100% !important;
      height: 100% !important;
    }
  }

  &:-moz-full-screen {
    width: 100vw !important;
    height: 100vh !important;
    background: #000 !important;
    
    > * {
      width: 100% !important;
      height: 100% !important;
    }
  }

  &:-ms-fullscreen {
    width: 100vw !important;
    height: 100vh !important;
    background: #000 !important;
    
    > * {
      width: 100% !important;
      height: 100% !important;
    }
  }

  ${props =>
    !props.hasVideo &&
    `
   ${container}
  margin: 4rem auto;

  ${minWidth.lg`
    margin: 8rem auto;
  `}
  `}

    /* Hide only the expand button (second button) in OptionsContainer, keep subtitles button (first button) */
    .V2__OptionsContainer-sc-5orbei-4 button:nth-child(2) {
    display: none !important;
  }
  /* Fallback: Hide only the last button in OptionsContainer */
  [class*='V2__OptionsContainer'] button:last-child {
    display: none !important;
  }
`;
